import React from 'react'
import { translate } from 'react-i18next'
import { func, arrayOf, shape, string } from 'prop-types'
import config from '../../config'

export const GardenersBulletList = translate()(({ t, gardeners, selected }) => {
    const select = gardeners.filter((g) => selected.indexOf(g.id) !== -1).map((it) => it.pictureFile ? it.pictureFile.path : config.profile_image_default)
    return (
        <div className="layout__container">
            <h3 className="demande-form__h3">{t('common:demande:gardeners_list', { count: selected.length })}</h3>
            <div className={ gardeners.length > config.max_garderners_bullets_images ? 'gardener-list display-placholder' : 'gardener-list '}>
                { select.filter((it, i) => i < config.max_garderners_bullets_images).map((it, index) => <img key={index} className="img--inline-rounded" src={it} alt='selected'/>) }
            </div>
        </div>
    )
})

GardenersBulletList.propTypes = {
    t: func,
    gardeners: arrayOf(shape({
        id: string,
        pictureFile: shape({ path: string })
    })),
    selected: arrayOf(string)
}



/*class GardenersBulletList extends Component {
    getSelectedJardiniersPictures() {
        let jardiniers = this.props.jardiniers || []
        jardiniers = jardiniers.content || jardiniers

        let selected = this.props.selected || []
        let rejected = this.props.rejected || []

        if (this.props.isAllChecked)
            return jardiniers.filter((it) => rejected.indexOf(it.id) === -1).map((it) => it.pictureFile ? it.pictureFile.path : config.profile_image_default)
        else
            return jardiniers.filter((it) => selected.indexOf(it.id) !== -1).map((it) => it.pictureFile ? it.pictureFile.path : config.profile_image_default)
    }
    
    render () {
      const { t } = this.props
      const jardiniers = this.getSelectedJardiniersPictures(this.props.jardiniers)

      return (
        <div className="layout__container">
            <h3 className="demande-form__h3">{t('common:demande:gardeners_list', { count: jardiniers.length })}</h3>
            <div className={ jardiniers.length > 10 ? 'gardener-list display-placholder' : 'gardener-list '}>
                {
                    jardiniers.filter((it, i) => i < 10).map((it, index) => <img key={index} className="img--inline-rounded" src={it} alt='selected'/>)
                }
            </div>
        </div>
      )
    }
  }
  
  const { array, bool, object } = PropTypes
  GardenersList.propTypes = {
    jardiniers: object,
    isAllChecked: bool,
    selected: array,
    rejected: array
  }
  
  export default translate()(GardenersList)*/
  


// WEBPACK FOOTER //
// ./src/components/gardeners/GardenersBulletList.js